import PropTypes from "prop-types";
import React, { useState } from 'react';

const Accordion = ({ChildComponent, title, isOpenByDefault, index }) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);

  const toggleAccordion = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <div className={`ds-accordion ${!isOpen ? 'ds-is--open' : ''}`}>
      <button
        onClick={toggleAccordion}
        aria-controls={`accordion-${index}`}
        className="ds-accordion__summary-wrapper"
        aria-expanded={isOpen}
      >
        {/* accordion summary */}
        <div className="ds-accordion__summary">
          <h4 className="ds-m-b-none">{title}</h4>
        </div>
        {/* plus icon */}
        <svg className="ds-accordion__icon">
          <use xlinkHref="#ds-general-expand" href="#ds-general-expand"></use>
        </svg>
        {/* minus icon */}
        <svg className="ds-accordion__icon ds-accordion__icon--minimise">
          <use xlinkHref="#ds-general-minimise" href="#ds-general-minimise"></use>
        </svg>
      </button>

      {/* accordion content */}

      { ChildComponent }
    </div>
  );
};

const AccordionComponent = ({ ChildComponent, data }) => {
  return (
    <>
      <Accordion ChildComponent={ChildComponent} title={data.title} index={data.index} isOpenByDefault={data.isOpen} />
    </>
  );
};


AccordionComponent.propTypes = {
  content: PropTypes.string,
  data: PropTypes.object,
  isOpenByDefault: PropTypes.bool,
};

Accordion.propTypes = {
  index: PropTypes.number,
  content: PropTypes.string,
  isOpenByDefault: PropTypes.bool,
  title: PropTypes.string,
};

export default AccordionComponent;
